import { invoiceAmounts } from '../../utils/invoiceAmounts';
import { formatRupiah, POPUP_BLOCKED_MESSAGE } from '../../utils/printHelper';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Label } from '../ui/label';
import { Printer } from 'lucide-react';
import { toast } from 'sonner';

export function VoucherKeteranganDialog({ printVoucherPembayaran, setShowVoucherDialog, setVoucherKeterangan, showVoucherDialog, voucherInvoice, voucherKeterangan }) {
  return (
    <Dialog open={showVoucherDialog} onOpenChange={setShowVoucherDialog}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Print Voucher Pembayaran</DialogTitle>
        </DialogHeader>
        {voucherInvoice && (
          <div className="space-y-4">
            <div className="bg-slate-50 p-3 rounded-lg text-sm">
              <p className="font-semibold">{voucherInvoice.invoice_number}</p>
              <p className="text-slate-500">No. Voucher: <span className="font-mono">{voucherInvoice.voucher_number || '-'}</span></p>
              <p className="text-slate-500">Nilai Dibayarkan: Rp {formatRupiah(invoiceAmounts(voucherInvoice).nilaiDibayarkan)}</p>
            </div>
            <div className="space-y-2">
              <Label>Keterangan Tambahan (Opsional)</Label>
              <textarea
                className="flex min-h-[80px] w-full rounded-md border border-input bg-white px-3 py-2 text-sm uppercase"
                value={voucherKeterangan}
                onChange={(e) => setVoucherKeterangan(e.target.value.toUpperCase())}
                placeholder="MASUKKAN KETERANGAN TAMBAHAN..."
                data-testid="voucher-keterangan-input"
              />
            </div>
            <div className="flex gap-2">
              <Button variant="outline" onClick={() => setShowVoucherDialog(false)} className="flex-1">Batal</Button>
              <Button
                className="flex-1 bg-purple-600 hover:bg-purple-700"
                onClick={() => {
                  // Tutup dulu, lalu cetak (print menunggu dokumen siap).
                  setShowVoucherDialog(false);
                  if (printVoucherPembayaran(voucherInvoice, voucherKeterangan) === false) {
                    toast.error(POPUP_BLOCKED_MESSAGE);
                    setShowVoucherDialog(true);
                  }
                }}
                data-testid="print-voucher-confirm"
              >
                <Printer className="h-4 w-4 mr-2" /> Print Voucher
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
